import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { styleSearchDetail } from "../../api/GetJewellery";
import { useFilters } from "../../context/FilterContext";
import PriceValue from "../../components/Common/PriceValue";
import { Tooltip } from "primereact/tooltip";
import { Image } from 'primereact/image';
import { Skeleton } from 'primereact/skeleton';
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Dropdown } from "primereact/dropdown";
import { useAuth } from "../../context/AuthContext";
import CustomerSelection from "../../components/Common/CustomerSelection";
import 'boxicons/css/boxicons.min.css';

export default function VaultAccessDetail() {
    document.title = "Vault Access Detail";

    const params = useParams();
    const { style_ID } = useParams();
    //const { fetchCartCount, fetchEnquiryCount } = useCount();
    const [product, setProduct] = useState(null);
    const [materials, setMaterials] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [modalImageIndex, setModalImageIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [collectionDetail, setCollectionDetail] = useState([]);
    const [addingToCart, setAddingToCart] = useState(false);
    const [isInCart, setisInCart] = useState([]);
    const [isInEnquiry, setisInEnquiry] = useState([]);
    const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);
    const [EnquiryItems, setEnquiryItems] = useState([]);
    const [productItem, setProductItem] = useState(null);
    const [EnquiryRemark, setEnquiryRemark] = useState("");
    const [submittingEnquiry, setSubmittingEnquiry] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [loadedImages, setLoadedImages] = useState({});
    const [tooltipOpen, setTooltipOpen] = useState({});
    const [toasts, setToasts] = useState([]);
    const [copied, setCopied] = useState(false);
    const isSkeletonLoading = !product;
    const { user, customerList, switchCustomer } = useAuth();

    const showToast = (toastData) => {
        setToasts((prev) => [...prev, { id: Date.now(), ...toastData }]);
    };

    const removeToast = (id) => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
    };

    const isInvalid = (val) => val === null || val === undefined || val === "" || Number(val) === 0;

    const formatPcsCts = (pcs, wt) => {
        return isInvalid(pcs) || isInvalid(wt) ? "-" : `${pcs} Pcs / ${wt} Cts`;
    };

    const toggleTooltip = (id) => {
        setTooltipOpen(prev => ({ ...prev, [id]: !prev[id] }));
    };

    const openModal = (index) => {
        setModalImageIndex(index);
        setShowModal(true);
    };

    const closeModal = () => setShowModal(false);

    const nextImage = () => {
        setModalImageIndex((prev) => prev === product.images.length - 1 ? 0 : prev + 1);
    };

    const prevImage = () => {
        setModalImageIndex((prev) => prev === 0 ? product.images.length - 1 : prev - 1);
    };

    const showValue = (value) => {
        if (
            value === null ||
            value === undefined ||
            value === "" ||
            Number(value) === 0
        ) {
            return null;
        }
        return value;
    };

    const fetchProductDetailData = async () => {
        try {
            setLoading(true);
            setError(null);

            const payload = {
                Party_ID: String(user.SelectedCustomer_ID),
                Style_ID: style_ID,
                PageNo: "1",
                PageSize: "50",
                Token: user.Token
            };
            
            const response = await styleSearchDetail(payload);
           
            const apiData = response?.data ?? response;
            const productsList = apiData?.Products ?? [];
            const materialsList = apiData?.MaterialDetail ?? [];
            const collectionsList = apiData?.CollectionDetail ?? [];

            if (productsList.length === 0) {
                throw new Error("Product not found");
            }
            const productItem = productsList[0];

            const mappedProduct = {
                Shortdescription: productItem.Shortdescription,
                Style_ID: productItem.Style_ID,
                Status: productItem.Status,
                StockType: productItem.StockType,
                MetalQuality: productItem.MetalQuality,
                MetalTone: productItem.MetalTone,
                ItemSize: productItem.ItemSize,
                StoneQuality: productItem.StoneQuality,
                JewelCode: productItem.JewelCode,
                StyleNo: productItem.StyleNo,
                Category: productItem.Category,
                HallmarkNo: productItem.HallmarkNo,
                CertificateNo: productItem.CertificateNo,
                GrossWt: productItem.GrossWt,
                TotalNetWt: productItem.TotalNetWt,
                DiaWt: productItem.DiaWt,
                DiaPcs: productItem.DiaPcs,
                CDiaWt: productItem.CDiaWt,
                CDiaPcs: productItem.CDiaPcs,
                NewArrivalStatus: productItem.NewArrivalStatus,
                PriceRemark: productItem.PriceRemark,
                LineAmount: productItem.LineAmount,
                LineDiscount: productItem.LineDiscount,
                images: [
                    productItem.Image1 || "/assets/images/VaultAccess/no-image3.png",
                    productItem.Image2 || "/assets/images/VaultAccess/no-image3.png",
                    productItem.Image3 || "/assets/images/VaultAccess/no-image3.png",
                    productItem.Image4 || "/assets/images/VaultAccess/no-image3.png",
                ].filter(Boolean),
            };

            const isTrue = (val) => ["YES", "TRUE", "1", "Y"].includes(String(val ?? "").toUpperCase());
            const isInCart = isTrue(productItem.IS_AddedInCart);
            const isInEnquiry = isTrue(productItem.IS_AddedInEnquiry);

            setisInCart(isInCart);
            setisInEnquiry(isInEnquiry);
            setProduct(productItem);
            const materialDetails = apiData?.MaterialDetail[0] || [];
            const collectionDetail = apiData?.CollectionDetail || [];
           
            setCollectionDetail(collectionDetail);
            setProduct(mappedProduct);
            setMaterials(materialDetails);
            addToRecentViews(mappedProduct);
        } catch (err) {
            console.error("Product detail error:", err);
            showToast({
                title: "Error!",
                message: err.message || "Failed to load product details",
                type: "error",
            });
            setProduct(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (style_ID) {
            fetchProductDetailData();
        } else {
            console.warn("style_ID is undefined or null");
        }
    }, [style_ID]);

    useEffect(() => {
        document.title = product ? `${product.Shortdescription} - Vault Access` : "Product Details";
    }, [product]);

    useEffect(() => {
        document.body.style.overflow = showModal ? "hidden" : "";
    }, [showModal]);

    const addToRecentViews = (product) => {
        let recent = JSON.parse(localStorage.getItem("recentViews")) || [];
        recent = recent.filter((p) => p.style_ID !== product.style_ID);
        recent.unshift(product);
        localStorage.setItem("recentViews", JSON.stringify(recent.slice(0, 8)));
    };
    //if (!loading && (error || !product)) {
    //    return (
    //        <VaultEmptyState
    //            title="Product Detail Not Found"
    //            description="Product details are currently unavailable.
    //                         This information may be temporarily inaccessible.
    //                         Please check back after some time or explore other designs available in Vault Access."
    //            showButton={true}
    //        />
    //    );
    //}

    const openEnquiryModal = (productItem) => {

        setEnquiryItems(prev => {
            const exists = prev.some(p => p.Style_ID === productItem.Style_ID);
            if (exists) return prev;

            return [
                ...prev,
                {
                    Style_ID: productItem.Style_ID,
                    StyleNo: productItem.StyleNo,
                    JewelCode: productItem.JewelCode,
                    Shortdescription: productItem.Shortdescription,
                    MetalQuality: productItem.MetalQuality,
                    MetalTone: productItem.MetalTone,
                    TotalNetWt: productItem.TotalNetWt,
                    Cart_ID: null,
                    Qunatity: 1
                }
            ];
        });
        setIsEnquiryOpen(true);

    };

    const resetEnquiryState = () => {
        setEnquiryItems([]);
        setEnquiryRemark("");
        setIsEnquiryOpen(false);
    };

    const removeEnquiryItem = (productId) => {
        setEnquiryItems(prev =>
            prev.filter(p => p.Style_ID !== productId)
        );
    };

    const submitEnquiry = async () => {
        if (!EnquiryItems.length) return;
        setSubmittingEnquiry(true);

        const payload = {
            Enquiry_ID: "0",
            EnquiryNo: "",
            Status: "PENDING",
            StatusComment: EnquiryRemark,
            StyleCount: String(EnquiryItems.length),
            Styles: EnquiryItems.map(x => ({
                Style_ID: x.Style_ID,
                StyleNo: x.StyleNo,
                JewelCode: x.JewelCode,
                Cart_ID: x.Cart_ID != null ? String(x.Cart_ID) : ""
            }))
        };

        //try {
        //    const res = await insertEnquiry(payload);
        //    console.log("response: ", res)
        //    if (res?.Message?.[0]?.ReturnCode !== "1") {
        //        console.error("Error inserting enquiry:", res?.ZMESSAGE);
        //        setCommonModalTitle("Error");
        //        setCommonModalMessage(res?.Message?.[0]?.ReturnMessage || "Failed to create enquiry");
        //        setCommonModalPageType("error");
        //        setIsCommonModalOpen(true);
        //        return;
        //    }
        //    console.log("Rsponse,", res)
        //    const messageObj = res?.EnquiryData?.[0];
        //    const rawMsg = messageObj?.ReturnMessage || "";
        //    const normalizedMsg = rawMsg.replace(/\s+/g, " ").trim();
        //    const enquiryNoMatch = normalizedMsg.match(/Enquiry\s*No\s*=\s*([A-Z0-9/]+)/i);
        //    const enquiryNo = enquiryNoMatch ? enquiryNoMatch[1] : "Enquiry Created";
        //    const cleanMessage = normalizedMsg
        //        .replace(/^\(\d+\)\s*/g, "")
        //        .replace(/\(Enquiry\s*No\s*=.*?\)/i, "")
        //        .trim();
        //    const style_IDs = EnquiryItems.map(x => x.Style_ID);
        //    markProductInEnquiry(style_IDs);
        //    setIsEnquiryOpen(false);
        //    //fetchEnquiryCount();
        //    setCommonModalTitle(enquiryNo);
        //    setCommonModalMessage(cleanMessage);
        //    setCommonModalPageType("enquiry");
        //    setIsCommonModalOpen(true);
        //    setisInEnquiry("YES");
        //} catch (err) {
        //    console.error("Exception inserting enquiry:", error);
        //    const ERRORMessage = err?.response?.data?.Message?.[0]?.ReturnMessage || err?.message || "Something went wrong";
        //    setCommonModalTitle("Error");
        //    setCommonModalMessage(ERRORMessage);
        //    setCommonModalPageType("error");
        //    setIsCommonModalOpen(true);
        //} finally {
        //    setSubmittingEnquiry(false);
        //}
    };

  

    const isValidEnquiryNo = (val) => {
        if (!val) return false;
        return /^[A-Z]{1,5}\/\d{1,4}\/\d{1,4}$/i.test(val);
    };

    const handleAddToCart = async (product) => {
        setShowLoader(false);
        //setAddingProductId(product.Style_ID);
        //try {
        //    const payload = {
        //        Style_ID: product.Style_ID,
        //        JewelCode: product.JewelCode,
        //        StyleNo: product.StyleNo,
        //        Quantity: "1",
        //    };
        //    const res = await AddToCart(payload);
        //    const messageObj = res?.ZMESSAGE?.[0];
        //    if (messageObj?.RETURNCODE === "1") {
        //        showToast({
        //            title: "Success!",
        //            message: messageObj?.RETURNMESSAGE,
        //            type: "success",
        //        });
        //        markProductInCart(product.Style_ID);
        //        fetchCartCount();
        //        setisInCart("Yes")
        //    } else {
        //        showToast({
        //            title: "Error!",
        //            message: messageObj?.RETURNMESSAGE || "Failed to add product",
        //            type: "error",
        //        });
        //    }
        //} catch (error) {
        //    console.error(error);
        //    showToast({
        //        title: "Error!",
        //        message: "Something went wrong",
        //        type: "error",
        //    });
        //} finally {
        //    setShowLoader(false);
        //    setAddingProductId(null);
        //}
    };

    const handleImageLoad = (index) => {
        setLoadedImages(prev => ({ ...prev, [index]: true }));
    };

    const handleImageError = (e, index) => {
        e.currentTarget.src = "/assets/images/vaultaccess/no-image3.png";
        setLoadedImages(prev => ({ ...prev, [index]: true }));
    };

    return (
        <>
            <section className="vault-header-detail-card">
                <div className="product-detail-header-left">
                    <h3 className="page-title">Product Detail</h3>
                </div>
                <div className="product-detail-header-right">
                    <div className="customer-wrapper">
                        <CustomerSelection />
                    </div>
                    <button className="back-btn" onClick={() => window.history.back()} aria-label="Go back">
                        <i className="pi pi-arrow-left"></i>
                    </button>
                </div>
            </section>

            <section className="Vault-access-detail vault-header-card mt-3">
                <div className="container-fluid">
                    {isSkeletonLoading ? (
                        <div className="row g-4 align-items-start">
                            <div className="col-lg-7 col-md-12">
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <div className="image-box w-100 position-relative"> </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="image-box w-100 position-relative"> </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="image-box w-100 position-relative"> </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="image-box w-100 position-relative"> </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-12">
                                <div className="Product-Detail-section">
                                    <div className="product-heading">
                                        <h3 className="fw-bold mb-3 d-flex align-items-center gap-2">
                                            <span className="text-primary fw-bold">
                                                <Skeleton width="450px" height="20px" />
                                            </span>
                                            <Skeleton width="50px" height="20px" />
                                            <Skeleton width="50px" height="20px" />
                                        </h3>
                                        <div className="d-flex align-items-baseline">
                                            <h5 className="fw-bold me-1">Product Code: </h5>
                                            <Skeleton width="140px" height="20px" />
                                        </div>
                                        <Skeleton width="140px" height="20px" className="mt-2" />
                                    </div>

                                    <div className="Details-section row">
                                        <div className="product-details">
                                            <h4 className="detail-heading fw-bold mt-2"> Product Details: </h4>
                                            <div><b>Gold Purity:</b>{" "} <Skeleton width="140px" height="20px" /></div>
                                            <div><b>Gold Weight:</b> <Skeleton width="140px" height="20px" /></div>
                                            <div><b>Dimension:</b> <Skeleton width="140px" height="20px" /></div>
                                        </div>
                                        <div className="diamond-details mt-2">
                                            <h4 className="detail-heading fw-bold"> Diamond Details: </h4>
                                            <div className="fw-bold"> Diamond Weight: <span className="fw-normal"><Skeleton width="140px" height="20px" /></span> </div>
                                            <div className="fw-bold"> Color Diamond: <span className="fw-normal"><Skeleton width="140px" height="20px" /></span> </div>
                                            <div className="fw-bold"> Gross Weight: <span className="fw-normal"><Skeleton width="140px" height="20px" /></span> </div>
                                            <div><b>Hallmark No:</b> <Skeleton width="140px" height="20px" /></div>
                                            <div><b>Certificate No:</b> <Skeleton width="140px" height="20px" /></div>
                                        </div>
                                    </div>
                                </div>

                                <div className="d-flex text-center mt-3">
                                        <span className="d-flex">
                                            <div className="enquiryBtn me-3">
                                                <Skeleton width="140px" height="35px" borderRadius="4px" />
                                            </div>
                                            <div className="cartBtn">
                                                <Skeleton width="140px" height="35px" borderRadius="4px" />
                                            </div>
                                        </span>
                                    </div>
                                <div className="py-3 bg-white shadow-sm rounded category-sidebar col-12 d-none">
                                    <h4 className="detail-heading fw-bold">Collection Details</h4>
                                    <ul className="list-unstyled mb-0 blog-list">
                                        {Array.from({ length: 4 }).map((_, i) => (
                                            <li className="mb-2" key={i}>
                                                <div className="small collection-item mb-0">
                                                    <i className="bx bx-wifi-0 fs-3"></i>
                                                        <Skeleton width="100px" height="20px" />
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="row g-4 align-items-start">
                            <div className="col-lg-7 col-md-12">
                                <div className="row g-3">
                                    {product.images.map((img, index) => (
                                        <div className="col-md-6" key={index}>
                                            <div className="" key={index}>
                                                <div className="image-box w-100 position-relative">
                                                    {!loadedImages[index] && (
                                                        <div className="skeleton-wrapper-vaultdetail">
                                                            <div className="skeleton-image-vaultdetail" />
                                                        </div>
                                                    )}
                                                   
                                                    <img
                                                        src={product.images[index]}
                                                        alt={`Product ${index + 1}`}
                                                        loading="lazy"
                                                        width="100%"
                                                        className="image-thumb img-fluid"
                                                        style={{
                                                            opacity: loadedImages[index] ? 1 : 0,
                                                            transition: "opacity 0.3s ease",
                                                        }}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={(e) => handleImageError(e, index)}
                                                    />
                                                    <button className="zoom-btn" onClick={(e) => { e.stopPropagation(); openModal(index); }}>
                                                        <i className="pi pi-search-plus"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-12">
                                <div className="Product-Detail-section">
                                    <div className="product-heading">
                                        <h3 className="fw-bold mb-3 d-flex align-items-center gap-2">
                                            <span className="product-name fw-bold">
                                                {product.Shortdescription || "Product Detail"}
                                            </span>
                                            {Number(product.Status) !== 0 && (
                                                <span className="badge badge-status badge-detail">
                                                    {String(product.Status).toUpperCase()}
                                                </span>
                                            )}

                                            {Number(product.NewArrivalStatus) !== 0 && (
                                                <span className="badge badge-new-arrival">
                                                    {String(product.NewArrivalStatus).toUpperCase()}
                                                </span>
                                            )}
                                        </h3>
                                        <div className="d-flex align-items-baseline">
                                            <h5 className="fw-bold me-1">Product Code: </h5>
                                            <span>{showValue(product.StyleNo)} /  {showValue(product.JewelCode)}</span>
                                        </div>
                                        <PriceValue
                                            lineAmount={product.LineAmount}
                                            lineDiscount={product.LineDiscount}
                                            priceRemark={product.PriceRemark}
                                        />
                                    </div>
                                    <div className="Details-section row">
                                        <div className="product-details">
                                            <h4 className="detail-heading fw-bold mt-2"> Product Details: </h4>
                                            <div className="mb-2"><b>Gold Purity:</b>{" "}{showValue(product.MetalQuality)} / {showValue(product.MetalTone)}</div>
                                            <div className="mb-2"><b>Gold Weight:</b> {showValue(product.TotalNetWt)}</div>
                                            <div className="mb-2"><b>Dimension:</b> {showValue(product.ItemSize)}</div>
                                        </div>
                                        <div className="diamond-details mt-2">
                                            <h4 className="detail-heading fw-bold"> Diamond Details: </h4>
                                            <div className="fw-bold mb-2"> Diamond Weight: <span className="fw-normal">{formatPcsCts(product.DiaPcs, product.DiaWt)}</span> </div>
                                            <div className="fw-bold mb-2"> Color Diamond: <span className="fw-normal">{formatPcsCts(product.CDiaPcs, product.CDiaWt)}</span> </div>
                                            <div className="fw-bold mb-2"> Gross Weight: <span className="fw-normal">{isInvalid(product.GrossWt) ? "-" : product.GrossWt}</span> </div>
                                            <div className="mb-2"><b>Hallmark No:</b> {showValue(product.HallmarkNo) || "-"}</div>
                                            <div className="mb-2"><b>Certificate No:</b> {showValue(product.CertificateNo) || "-"}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex text-center mt-3">
                                    <span
                                        id={`detail-enquiry-btn-${product.Style_ID}`}
                                        className="me-3 d-inline-block"
                                        style={{ cursor: isInEnquiry ? "not-allowed" : "pointer" }}
                                    >
                                        <button
                                            type="button"
                                            className={`btn-animate-enquiry fs-6 ${isInEnquiry ? "btn-outline-enquiry disabled-btn" : ""}`}
                                            disabled={isInEnquiry}
                                            onClick={() => { console.log("Product Item clicked:"); }}
                                        >
                                            {/*onClick={() => openEnquiryModal(productItem)}*/}
                                            {isInEnquiry ? "IN ENQUIRY" : "ENQUIRE NOW"}
                                        </button>
                                    </span>

                                    {isInEnquiry && (
                                        <Tooltip
                                            fade={false}
                                            placement="top"
                                            isOpen={!!tooltipOpen[`detail-enquiry-btn-${product.Style_ID}`]}
                                            target={`detail-enquiry-btn-${product.Style_ID}`}
                                            toggle={() =>
                                                toggleTooltip(`detail-enquiry-btn-${product.Style_ID}`)
                                            }
                                        >
                                            This product is already added to enquiry
                                        </Tooltip>
                                    )}

                                    <span
                                        id={`detail-cart-btn-${product.Style_ID}`}
                                        className="d-inline-block"
                                        style={{ cursor: isInCart || isInEnquiry ? "not-allowed" : "pointer" }}
                                    >
                                        <button
                                            type="button"
                                            className={`btn-animate-addtocart fs-6 ${isInCart ? "btn-outline-cart disabled-btn" : isInEnquiry ? "disabled-btn" : "" }`}
                                            disabled={isInCart || isInEnquiry || addingToCart}
                                            onClick={() => { console.log("Product Item clicked:"); }}
                                        >
                                            {/*onClick={() => handleAddToCart(productItem)}*/}
                                            {isInCart ? "IN CART" : "ADD TO CART"}
                                        </button>
                                    </span>

                                    {(isInCart || isInEnquiry) && (
                                        <Tooltip
                                            fade={false}
                                            placement="top"
                                            isOpen={!!tooltipOpen[`detail-cart-btn-${product.Style_ID}`]}
                                            target={`detail-cart-btn-${product.Style_ID}`}
                                            toggle={() =>
                                                toggleTooltip(`detail-cart-btn-${product.Style_ID}`)
                                            }
                                        >
                                            {isInCart
                                                ? "This product is already in your cart"
                                                : "Products in enquiry can’t be added to cart"}
                                        </Tooltip>
                                    )}
                                </div>
                                <div className="py-3 bg-white category-sidebar col-12">
                                    <h4 className="detail-heading fw-bold">Collection Details</h4>
                                    <ul className="list-unstyled mb-0 blog-list">
                                        {(collectionDetail || []).map((collection, i) => (
                                            <li className="mb-2" key={i}>
                                                <p className={`small collection-item mb-0 ${collection.ISBaseCollection ? "fw-bold text-primary base-collection" : ""}`}>
                                                    <i className="bx bx-wifi-0 fs-3"></i>
                                                    <span>{collection.Collection}</span>
                                                    {collection.ISBaseCollection && (
                                                        <span className="base-collection-hover"> Base Collection </span>
                                                    )}
                                                </p>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    )}
                    {showModal && (
                        <div className="fullscreen-modal" onClick={closeModal}>
                            <button className="modal-close-btn" onClick={closeModal} aria-label="Close">
                                <i className="pi pi-times"></i>
                            </button>
                            <div className="modal-image-wrapper" onClick={(e) => e.stopPropagation()}>
                                <Image
                                    src={product.images?.[modalImageIndex] || "/assets/images/VaultAccess/no-image.png"}
                                    zoomSrc={product.images[modalImageIndex]}
                                    zoomType="click"
                                    moveType="drag"
                                    zoomScale={2}
                                    hasSpacer={false}
                                    onError={(e) => {
                                        e.target.src = "/assets/images/VaultAccess/no-image.png";
                                    }}
                                />
                            </div>
                            <div className="modal-pagination" onClick={(e) => e.stopPropagation()}>
                                <button onClick={prevImage}>
                                    ‹
                                </button>

                                <span> {modalImageIndex + 1} / {product.images.length} </span>

                                <button onClick={nextImage}>
                                    ›
                                </button>
                            </div>
                        </div>
                    )}
                    {/*<SimilarProductsSlider*/}
                    {/*    currentProductId={style_ID}*/}
                    {/*    category={product.category}*/}
                    {/*/>*/}
                    {/*<RecentViewedSlider />*/}
                </div>
            </section>

        </>
    );
}
            //<CommonToastContainer toasts={toasts} removeToast={removeToast} />
/*  <CommonPopUpModal
    isOpen={isCommonModalOpen}
    onClose={() => setIsCommonModalOpen(false)}
    message={commonModalMessage}
    pageType={commonModalPageType}
    title={
        commonModalPageType === "enquiry" ? (
            <>
                <div className="popup-subtitle">
                    Thanks for reaching out to us.
                </div>

                <div className="popup-enquiry-label">
                    Your Enquiry No is
                </div>

                <div
                    className={`popup-enquiry-no ${isValidEnquiryNo(commonModalTitle) ? "copyable" : ""
                        }`}
                    onClick={copyEnquiryNo}
                    title={
                        isValidEnquiryNo(commonModalTitle)
                            ? "Click to copy"
                            : ""
                    }
                >
                    <span>{commonModalTitle}</span>

                    {isValidEnquiryNo(commonModalTitle) && (
                        <span className={`copy-wrapper ${copied ? "copied" : ""}`}>
                            <i className="bx bx-copy copy-icon" />
                            {copied && (
                                <span className="copied-tooltip">
                                    Copied!
                                </span>
                            )}
                        </span>
                    )}
                </div>
            </>
        ) : (
            commonModalTitle
        )
    }
/>*/

//<EnquiryModal
//    isOpen={isEnquiryOpen}
//    toggle={resetEnquiryState}
//    items={EnquiryItems}
//    remark={EnquiryRemark}
//    setRemark={setEnquiryRemark}
//    onRemoveItem={removeEnquiryItem}
//    onSubmit={submitEnquiry}
//    submitting={submittingEnquiry}
//    title="Product Enquiry"
///>